export default __webpack_public_path__ + "static/lending-tree-top-10-lender-q4-2021-250801fdc61b40982faf383b5b7d77cc.png";